import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class DownloadBar extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get leftText() {
    return get(this, '_left_text.value', '');
  }

  get buttonText() {
    return get(this, '_button_text.value', '');
  }

  get fileLink() {
    return get(this, '_file_link[0]', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }

}



// WEBPACK FOOTER //
// ./src/models/DownloadBar.model.js